import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ClassifiersSearch} from '../../../models/classifiers-search.interface';

@Component({
  selector: 'app-classifiers-filters',
  templateUrl: './classifiers-filters.component.html',
  styleUrls: ['./classifiers-filters.component.scss']
})
export class ClassifiersFiltersComponent implements OnInit {

  searchForm = this.formBuilder.group({
    code: [''],
    description: [''],
    status: ['ACTIVE']
  });

  get codeControl(): FormControl {
    return this.searchForm.get('code') as FormControl;
  }
  get descriptionControl(): FormControl {
    return this.searchForm.get('description') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Output()
  search: EventEmitter<ClassifiersSearch> = new EventEmitter<ClassifiersSearch>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    this.search.emit({
      code: this.codeControl.value,
      description: this.descriptionControl.value,
      status: this.statusControl.value
    });
  }

  clean(): void {
    this.search.emit({});
  }

}
